<template>
    <v-app>
        <app-header />
        <div class="mgt-60 bg-main">
            <router-view></router-view>
        </div>

        <img
            @click="goWhatsapp()"
            class="beta-call"
            :src="require('@/assets/images/beta-call.svg')"
        />

        <app-footer />
    </v-app>
</template>

<script>
import { useDisplay } from 'vuetify';
import AppHeader from './modules/global/components/AppHeader.vue';
import AppFooter from './modules/global/components/AppFooter.vue';

export default {
    name: 'App',
    setup() {
        const display = useDisplay();
        return { display };
    },
    provide() {
        return {
            display: this.display,
        };
    },
    components: {
        AppHeader,
        AppFooter,
    },
    methods: {
        goWhatsapp() {
            const phone = '6285179519144';
            const text = encodeURIComponent(
                'Halo, saya tertarik dengan aplikasi Skolla. Bisa dibantu?'
            );

            window.open(`https://wa.me/${phone}?text=${text}`, '_blank');
        },
    },
};
</script>
